import { useEffect} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllGroups } from 'store/entities/groups/action';
import Table from 'components/__new/common/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLocation  } from 'react-router-dom';
import { getPayGroups } from 'store/entities/payroll/payrollSetup/action';
import Spinner from '../common/Spinner';
import BulkActionHandler from '../common/BulkActionHandler';

const CompactGroups = ({selected, setSelected, showAll, limit, setLimit}) => {
    const location = useLocation();
    const dispatch = useDispatch()
    const {getPayGroupData: data, getPayGroupLoading: loading} = useSelector(state => state.entities.payrollSetup)


    const allGroupIDs = data?.data?.map(item => item.id)
    const emptyGroups = !loading && data?.data?.length < 1

    const toggleSingleGroup = (id) => {
        const alreadyExists = selected?.indexOf(id) > -1
        if (alreadyExists) {
            const filtered = selected?.filter(item => item !== id)
            setSelected(filtered)
        } else {
            setSelected([...selected, id])
        }
    }

    const toggleEntireList = () => {
        if (selected.length !== allGroupIDs?.length) {
            setSelected(allGroupIDs)
        } else {
            setSelected([])
        }
    }

    useEffect(() => {
        dispatch(getAllGroups())
        dispatch(getPayGroups());
        // eslint-disable-next-line
    }, [location])

    return (
        <div>
            {loading ? <Spinner message="Fetching Pay Groups" /> : emptyGroups ? <div className="table-info">
                <FontAwesomeIcon icon="unlink" />
                <div className="font-semibold uppercase">
                    No Pay Groups Found
                </div>
            </div> : <div className="mt-6 bg-white p-5">
                {selected?.length > 0 && 
                    <div className='my-5'>
                        <BulkActionHandler count={selected?.length} onCancel={() => setSelected([])} countOnly />
                    </div>}
                    <Table>
                        <Table.Head>
                            <th>
                            <div className="flex items-center">
                            <div className="mr-6">
                                <input onChange={() => toggleEntireList()}
                                checked={selected.length === allGroupIDs?.length}
                                type="checkbox" className="w-5 h-5 mr-3.5 form-checkbox float-left" />
                            </div>
                            <p className="mb-0">Name of Pay Group</p>
                            </div>
                            </th>
                            <th>No. of Employees</th>
                        </Table.Head>
                        <Table.Body className='border'>
                            {data?.data?.slice(0, limit)?.map((group) =>
                                <tr key={group.id}>
                                    <td>
                                    <div className='flex items-center'>
                                        <div className="mr-6">
                                        <input onChange={() => toggleSingleGroup(group.id)}
                                            checked={selected?.includes(group.id)}
                                            type="checkbox" className="w-5 h-5 mr-2 form-checkbox float-left" />
                                        </div>
                                        <p className="mb-0 capitalize">{group.name?.toLowerCase()}</p>
                                        </div>
                                    </td>
                                    <td>
                                        <div className='flex items-center'>
                                            {group?.employee_ids?.length}
                                        </div>
                                    </td>
                                </tr>
                            )}
                        </Table.Body>
                    </Table>
                    <div className="mt-4 w-full ml-14">
                        <button disabled={showAll} onClick={() => setLimit((prev) => prev + 10)} className="flex items-center btn btn-sm btn-transparent-primary">
                            Add new rows
                        </button>
                    </div>
            </div>}
        </div>
    )
}

export default CompactGroups